import { format } from 'date-fns';

export interface Tile { value: number; delta_pct: number | null; connected: boolean; }
export interface SnapshotTile { value: number; connected: boolean; }

export const inr = (n: number) => `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
export const num = (n: number) => n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
export const pctFmt = (n: number) => `${n.toLocaleString('en-IN', { maximumFractionDigits: 1 })}%`;
export const toISO = (d: Date) => format(d, 'yyyy-MM-dd');

export function deltaMeta(tile?: Tile): { change: string; trend: 'up' | 'down' | 'neutral' } {
  if (!tile || !tile.connected) return { change: 'Not Connected', trend: 'neutral' };
  if (tile.delta_pct === null) return { change: 'vs previous period', trend: 'neutral' };
  const sign = tile.delta_pct > 0 ? '+' : '';
  const trend: 'up' | 'down' | 'neutral' = tile.delta_pct > 0 ? 'up' : tile.delta_pct < 0 ? 'down' : 'neutral';
  return {
    change: `${sign}${tile.delta_pct.toLocaleString('en-IN', { maximumFractionDigits: 1 })}% vs prev period`,
    trend,
  };
}

export function snapshotMeta(tile?: SnapshotTile): { change: string; trend: 'up' | 'down' | 'neutral' } {
  if (!tile || !tile.connected) return { change: 'Not Connected', trend: 'neutral' };
  return { change: 'Live snapshot', trend: 'neutral' };
}
